export enum CollectionErrorCode {
    COLLECTION_IS_REFERENCED = "COLLECTION_IS_REFERENCED",
    CODE_USED_BY_ANOTHER_COLLECTION = "CODE_USED_BY_ANOTHER_COLLECTION",
}
